import React from 'react'
import PropTypes from 'prop-types'
import MediaWithinText from './MediaWithinText'
import TextStatusIndicator from './TextStatusIndicator'
import { formatTime } from './utils'
import styles from './styles/Text'

const Text = ({
  message,
  handleExpandedMessage,
  hasRemindersTier2,
  unknownNumber,
  practiceName,
  showMmsFromUnknownNumbers,
}) => {
  const showEntireMessage =
    !message.media_url || !!message.body || hasRemindersTier2
  const type = message.to_patient ? 'toPatient' : 'fromPatient'

  const dateTimeStamp = message.sent_at
    ? formatTime(message.sent_at, true).split(', ')
    : formatTime(message.created_at, true).split(', ')

  // show media from unknown numbers for The Smile Design of Atlanta
  const unknownWithMMS =
    unknownNumber && !!message.media_url && type === 'fromPatient'
  const body = unknownWithMMS && !showMmsFromUnknownNumbers ? '<Picture Message Blocked>' : message.body
  const showMedia = !!message.media_url && hasRemindersTier2 && (!unknownWithMMS || showMmsFromUnknownNumbers)
  const showStatus = message.to_patient

  return (
    <div style={styles.outerWrapper}>
      {showEntireMessage && (
        <div>
          <div
            style={
              message.to_patient
                ? styles.currentUser_time
                : styles.fromPatient_time
            }
          >
            {dateTimeStamp[0]}
            {'\n'}
            {dateTimeStamp[1]}
          </div>
          <div
            style={message.to_patient ? styles.currentUser : styles.fromPatient}
            className={type}
          >
            {showMedia && (
              <MediaWithinText
                id={message.id}
                type={type}
                url={message.media_url}
                handleExpandedMessage={handleExpandedMessage}
              />
            )}
            {body}
          </div>
          {showStatus && (
            <TextStatusIndicator
              status={message.status}
              errorCode={message.error_code}
            />
          )}
        </div>
      )}
    </div>
  )
}

Text.propTypes = {
  hasRemindersTier2: PropTypes.bool.isRequired,
  handleExpandedMessage: PropTypes.func.isRequired,
  message: PropTypes.shape({
    media_url: PropTypes.string,
    created_at: PropTypes.string.isRequired,
    to_patient: PropTypes.bool.isRequired,
    body: PropTypes.string,
  }).isRequired,
  unknownNumber: PropTypes.bool,
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Messages/Text.js